import BlockGen from "@/features/triangle-rewards/classes/BlockGen";
import WeatherPromos from "@/features/weather/WeatherPromos.vue";
import PersonalizationApi from "@/features/offers/api/PersonalizationApi";

export default (pages, pagesIndex, insertPageNum, unitWidth, unitHeight, storeId, bannerId, lang, flyerTitle) => {
    let weatherPromosData= null;
    let isTempEligible;
    let validConditions = false;
    const validPubs = ["D0317", "D0318","D0319","D0320","D0321"]
    let isValidPub = false;
    
    const fetchData = async() => {
        if(weatherPromosData) return;
    try {
        const data = await PersonalizationApi.GetWeatherPromos(storeId, bannerId, lang);
            
        weatherPromosData = data
        isTempEligible = data.isTempEligible
         //isTempEligible = true;
       isValidPub = validPubs.includes(flyerTitle)
        const currentDate = new Date();
        const startDateQuebec = new Date(currentDate.getFullYear(), 2, 15);
        const startDate = new Date(currentDate.getFullYear(), 2, 13);
        const endDate = new Date(currentDate.getFullYear(), 4, 22);
       const isQuebec = weatherPromosData.storeName.split(',')[1]?.includes('QC');
       validConditions = (isQuebec && currentDate >= startDateQuebec && currentDate <= endDate) || (!isQuebec && currentDate >= startDate && currentDate <= endDate)
    }catch (e) {
        return null
    }
   }
    
    const generatePage = async () => {
     if(!weatherPromosData) {await fetchData();}
        const horizontalMode = document.querySelector('#app [flyer-orientation="horizontal"]')
        const isDesktop = () => window.innerWidth >= 1024
        let adjustedUnitWidth = isDesktop() && horizontalMode ? unitWidth + 40 : unitWidth;
         const weatherPromosPage = {
           id: "weatherPromos",
           publicationId: "weatherPromos",
           name: "weatherPromos",
           props: { weatherPromosData },
           data: weatherPromosData,
           width: 0,
           height: 0,
           isAdPage: false,
           disclaimer: null,
           unitWidth: adjustedUnitWidth,
           unitHeight: unitHeight,
           countTowardsPageCount: false,
           basebars: {
             desktop: [
               {
                 text:
                   lang === "en"
                     ? "Schedule a convenient tire changeover service today"
                     : "Planifez un changement de pneus pratique dès aujourd’hui",
                 link: lang === "en" ? "Book Now" : "Rèservez maintenant",
               },
             ],
             tablet: [
               {
                 text:
                   lang === "en"
                     ? "Schedule a convenient tire changeover service today"
                     : "Planifez un changement de pneus pratique dès aujourd’hui",
                 link: lang === "en" ? "Book Now" : "Rèservez maintenant",
               },
             ],
             mobile: [
               {
                 text:
                   lang === "en"
                     ? "Schedule a convenient tire changeover service today"
                     : "Planifez un changement de pneus pratique dès aujourd’hui",
                 link: lang === "en" ? "Book Now" : "Rèservez maintenant",
               },
             ],
           },

           grids: {
             desktop: {
               rowCount: 4,
               colCount: 3,
             },
             tablet: {
               rowCount: 3,
               colCount: 3,
               fitCols: 5,
               style: {
                 fontSize: "13px",
               },
             },
             mobile: {
               rowCount: 3,
               colCount: 2,
               fitCols: 3,
               style: {
                 fontSize: "13px",
               },
             },
           },
           blocks: [
             BlockGen.GenBlock( 3,4,unitWidth, unitHeight, {}, { id: "weatherPromos",type: "component",component: WeatherPromos,props: { weatherPromosData },}),
           ],
         };
      const existingIndex = pages.findIndex(page => page.id === 'weatherPromos');
      if (existingIndex !== -1 ) {
        pages.splice(existingIndex, 1)
      }

      if (isTempEligible && validConditions && isValidPub) { pages.splice(pagesIndex[insertPageNum], 0, weatherPromosPage)} }

    generatePage();
    window.addEventListener('resize', generatePage)
    window.addEventListener('click', generatePage)


}
